import FileInfo from './FileInfo.component';

export default FileInfo;